module.exports = __webpack_public_path__ + "static/media/show-icon.e376f43f.svg";